import { normalizeApiBaseUrl, type AppConfig } from '@edice/shared';
import { bootstrapAuthenticatedApp } from '@edice/shared/auth';
import '@edice/shared/shell.css';
import { registerSW } from 'virtual:pwa-register';

const config: AppConfig = {
  appKind: 'osc',
  appName: 'OSC BPF Perak',
  shortName: 'OSC',
  description: 'Ruang operasi negeri untuk merancang aktiviti, mengurus tindakan dan berkongsi kandungan terkawal dengan eDICE.',
  environment: (import.meta.env.VITE_APP_ENV || 'development') as AppConfig['environment'],
  apiBaseUrl: normalizeApiBaseUrl(import.meta.env.VITE_API_BASE_URL),
  accent: '#1f4f78',
  modules: [
    { id: 'aktiviti', label: 'Perancangan Aktiviti', description: 'Aktiviti OSC sahaja atau diterbitkan kepada fasiliti.', status: 'available' },
    { id: 'rebeca', label: 'ReBeCa', description: 'Rekod belanja cawangan yang dipautkan kepada aktiviti.', status: 'planned' },
    { id: 'pelan-tindakan', label: 'Pelan Tindakan', description: 'Tindakan peringkat Negeri, KKM dan fasiliti.', status: 'planned' },
    { id: 'kandungan', label: 'Kandungan Bersama', description: 'Pengumuman, status ubat, dokumen dan maklum balas.', status: 'available' },
    { id: 'aduan', label: 'Aduan & Aset', description: 'Ticket, timeline dan status penyelesaian.', status: 'planned' },
    { id: 'time-off', label: 'Time Off', description: 'Kebenaran keluar dan penggantian jam.', status: 'planned' }
  ]
};

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('Elemen aplikasi tidak dijumpai.');

void bootstrapAuthenticatedApp(root, config, {
  clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
  allowedDomain: import.meta.env.VITE_GOOGLE_DOMAIN || 'moh.gov.my',
  authMode: import.meta.env.VITE_AUTH_MODE === 'google' ? 'google' : 'mock'
});
registerSW({ immediate: true });
